import { AbstractJsonApiService } from './abstract-json-api.service';
import { SelectableAddress } from '@ipensii/shared/domain-shared';

export class AddressService extends AbstractJsonApiService<SelectableAddress> {
  constructor() {
    super('address');
  }

  getAllCountries() {
    return this.http.get<SelectableAddress[]>('/assets/ipensii/data/country-list.json');
  }

  getAllCounties() {
    return this.http.get<SelectableAddress[]>('/assets/ipensii/data/county-list.json');
  }
}
